import { SysFile } from "../../../components";

function SysFiles({ loan }) {

    const files = loan?.sysFiles;

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
            <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">System Files</h4>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    <thead>
                        <tr className="border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60">
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Name</th>
                            <th scope="col" className="px-5 py-3 text-right text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                        {files && files.length > 0 ?
                            files.map((file, index) => (
                                <SysFile
                                    key={index}
                                    file={file}
                                    loanId={loan?.loanId}
                                    phone={loan?.phone}
                                />
                            ))
                        :
                            <tr>
                                <td colSpan={2} className="px-5 py-10 text-center text-sm text-gray-400">
                                    No system files uploaded.
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default SysFiles;
